interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
}

export default function ConfirmModal({
  title,
  message,
  confirmLabel = "Sil",
  onConfirm,
  onCancel,
  danger = true,
}: ConfirmModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-2xl">
        <div className="flex items-start gap-4 mb-5">
          <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 ${danger ? "bg-red-100" : "bg-amber-100"}`}>
            <i className={`ri-alert-line text-lg ${danger ? "text-red-600" : "text-amber-600"}`} />
          </div>
          <div>
            <h3 className="font-bold text-stone-800 mb-1">{title}</h3>
            <p className="text-sm text-stone-500 leading-relaxed">{message}</p>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 border border-stone-200 rounded-xl text-sm text-stone-600 hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            İptal
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 py-2.5 rounded-xl text-sm font-semibold text-white transition-colors cursor-pointer whitespace-nowrap ${
              danger ? "bg-red-600 hover:bg-red-700" : "bg-amber-600 hover:bg-amber-700"
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
